// GES-435 D: the ADMIN's replacement of a FREE avoir number at issue. Pre-filled from GET /document-numbering/preview; the server says `overridable` only for an admin on a free series,
// so anyone else (or a legal series) sees nothing. Calls onChange(number) with the typed number, or null while it is the untouched pre-fill (the server then numbers it itself).
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../../services/api';
import { TextInput } from '../../inputs/Input';

export default function AvoirNumberField({ kind = 'avoir_correction', date, onChange }) {
  const { t } = useTranslation('avoir');
  const [pv, setPv] = useState(null); const [v, setV] = useState('');
  useEffect(() => {
    let live = true; onChange?.(null);
    api.previewDocumentNumber(kind, date).then(r => { if (live) { setPv(r?.overridable ? r : null); setV(r?.no || ''); } }).catch(() => live && setPv(null));
    return () => { live = false; };
  }, [kind, date]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (!pv) return null;
  return (
    <div className="field full" data-testid="avoir-number-field"><label htmlFor="av-number">{t('numberReplace')}</label>
      <TextInput id="av-number" type="text" maxLength={60} value={v} onChange={e => { setV(e.target.value); onChange?.(e.target.value.trim() && e.target.value.trim() !== pv.no ? e.target.value.trim() : null); }} />
      <span className="sub">{t('numberReplaceHint')}</span></div>
  );
}
